export default __webpack_public_path__ + "static/media/carousel3.b4d5ea2f.jpg";